export class ModuleConfiguration {
  static moduleName = 'datawarehouse';
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/datawarehouse.module.config.ts